import React from 'react'
import { Container, Panel, Button } from '@sencha/ext-modern'

const Waiting = () => {
	return <Container fullScreen layout={{ type: 'vbox', align: 'center' }} padding={10}>
		<Panel ui="instructions" margin="30 0 10 0">
			<Button
				ui="none"
				text="数据加载中..."
			// iconCls={"x-fa fa-spinner fa-spin"}
			/>
		</Panel>
	</Container>
}

export default Waiting